
import Service from "../Service";

const resource = "HmnConfigSegurityEq/";

export default {

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID }
        });
    },
    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },
    List(obj, requestID) {
        console.log('obj', obj);
        return Service.post(resource + "list", obj, {
            params: { requestID: requestID },
        });
    },
};